import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    projectsGridContainer:{
        margin: '0px auto',
        padding: '0',
    },
    projectGridContainer:{
        width:'420px',
        margin: '0px auto'
    }
}));